module.exports = __webpack_public_path__ + "440477997b670c083d2ae6c20c56c68d.svg";